export function ClaimHeader({ showActions = true }: { showActions?: boolean }) {
  return (
    <div className="claim-header">
      <div className="claim-header-icon" />
      <div className="claim-header-vehicle">
        <svg width="20" height="14" viewBox="0 0 24 16" fill="currentColor">
          <path d="M3 8l2-5h14l2 5v6h-2v-2H5v2H3V8zm2 0h14l-1-3H6L5 8zm1 4a1 1 0 1 0 0-2 1 1 0 0 0 0 2zm12 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2z" />
        </svg>
      </div>
      <div className="claim-header-field">
        <span className="claim-header-label">Pol:</span>
        <span className="claim-header-value">P000143542</span>
      </div>
      <div className="claim-header-field">
        <span className="claim-header-label">Ins:</span>
        <span className="claim-header-value">Jackie Chen</span>
      </div>
      <div className="claim-header-field">
        <span className="claim-header-label">DoL:</span>
        <span className="claim-header-value">03/15/2026</span>
      </div>
      <div className="claim-header-field">
        <span className="claim-header-label">Adj:</span>
        <span className="claim-header-value">Super User (Acme Insurance)</span>
      </div>
    </div>
  );
}
